<template>
  <div class="rt-icon" @click="click">
    <svg
      v-if="!!iconName"
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <use :xlink:href="'#' + iconName" :fill="color" />
    </svg>
    <img
      v-if="!!iconSrc"
      :width="size"
      :src="iconSrc"
      :height="size"
      @error="errorHandler"
    />
  </div>
</template>

<script>
import config from '../../config';
export default {
  name: 'RtIcon',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    name: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 16
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String
    }
  },
  data() {
    return {
      iconName: this.name,
      iconSrc: this.imgSrc
    };
  },
  watch: {
    imgSrc() {
      this.iconSrc = this.imgSrc;
    },
    name() {
      this.iconName = this.name;
    }
  },
  methods: {
    click(event) {
      if (!this.disabled) this.$emit('click', event);
    },
    errorHandler(e) {
      this.iconSrc = '';
      this.iconName = config.get().defaultIconName;
      console.log('image load error');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtIcon.vue?39f64453